import { map, mergeMap, exhaustMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadFilteredUsersSuccess } from '../actions/common.actions';

import { StockroomService } from '@core/services/stockroom/stockroom-api';
import * as allActions from '../actions/common.actions';
import { PrivilegeService } from '@core/services/privilege/privilege-api';
import { AppService } from '@core/services/app/app-api';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';

@Injectable()
export class CommonEffects {
  currentUser: any = this.appService.getUserData();
  constructor(
    private actions$: Actions,
    private stockroomService: StockroomService,
    private privilegeService: PrivilegeService,
    private appService: AppService,
    private orgAndStockroomService: OrgAndStockroomService
  ) { }

  loadUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.loadFilteredUsers),
      mergeMap(action => {
        return this.stockroomService.getUsersObservable().pipe(
          map((res: any) => {
            let users = res.data;
            if (
              !this.privilegeService.findPrivelege('priv_general_select_user')
            ) {
              if (
                !this.privilegeService.findChildPrivelege(
                  'priv_general_select_user'
                )
              ) {
                users = res.data.filter(
                  (el: any) => el.id === this.currentUser.id
                );
              }
            }
            return loadFilteredUsersSuccess({ users: users });
          })
        );
      }),
      catchError(error => of(loadFilteredUsersSuccess({ users: [] })))
    );
  });

  loadStockroomOrg$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.invokeStockroomOrgAPI),
      mergeMap(action => {
        return this.orgAndStockroomService.fetchStockroomOrg().pipe(
          map((repsonse: any) => {
            return allActions.stockroomOrgFetchAPISuccess({
              stockroomOrg: {
                stockroom: repsonse[1],
                organization: repsonse[0],
              },
            });
          })
        );
      }),
      catchError(error =>
        of(
          allActions.stockroomOrgFetchAPISuccess({
            stockroomOrg: {
              stockroom: {},
              organization: {},
            },
          })
        )
      )
    );
  });

  loadPrivilege$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.loadPrivileges),
      mergeMap(action => {
        return this.privilegeService.initUserPrivilegeAsObs().pipe(
          map((res: any) => {
            let privileges = res;
            return allActions.setPrivileges({ privileges: privileges });
          })
        );
      }),
      catchError(error => of(allActions.setPrivileges({ privileges: [] })))
    );
  });

  loadUserConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(allActions.loadUserConfig),
      mergeMap(action => {
        return this.appService.initUserDataAsObs().pipe(
          map((res: any) => {
            let config = res;
            return allActions.setUserConfig({ config: config });
          })
        );
      }),
      catchError(error => of(allActions.setUserConfig({ config: {} })))
    );
  });
}
